import { useNavigate } from 'react-router-dom';

function PaginaInstitucional({ titulo, children }) {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#F8F7F4', fontFamily: "'Sora', sans-serif" }}>
      <header style={{ background: '#1A1A2E', padding: '14px 20px', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: 700, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'rgba(255,255,255,.1)', border: 'none', color: '#fff',
            borderRadius: 10, width: 36, height: 36, cursor: 'pointer', fontSize: '1.1rem',
          }}>←</button>
          <h1 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>{titulo}</h1>
        </div>
      </header>
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '32px 20px 60px' }}>
        <div style={{ background: '#fff', borderRadius: 20, padding: '32px 28px', border: '1px solid #eee', lineHeight: 1.7 }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export function Termos() {
  return (
    <PaginaInstitucional titulo="Termos de Uso">
      <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Termos de Uso</h2>
      <p style={{ color: '#888', fontSize: '.85rem', marginBottom: 24 }}>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

      {[
        { t: '1. Aceitação dos Termos', c: 'Ao utilizar este cardápio digital, você concorda com os presentes Termos de Uso. Caso não concorde, por favor, não utilize nossos serviços.' },
        { t: '2. Uso do Serviço', c: 'Este serviço destina-se exclusivamente à realização de pedidos de produtos disponíveis no cardápio. É proibido qualquer uso indevido, fraudulento ou que viole a legislação vigente.' },
        { t: '3. Pedidos', c: 'Ao realizar um pedido, você confirma que as informações fornecidas são verdadeiras e que concorda com os valores, condições de entrega e formas de pagamento disponíveis. O estabelecimento poderá cancelar pedidos em caso de indisponibilidade de produtos.' },
        { t: '4. Pagamento', c: 'Os pagamentos podem ser realizados nas modalidades disponíveis no checkout. O estabelecimento é responsável pela confirmação e processamento do pagamento.' },
        { t: '5. Entrega', c: 'O prazo de entrega é estimado e pode variar de acordo com a demanda e condições externas. O estabelecimento envidará seus melhores esforços para cumprir os prazos informados.' },
        { t: '6. Cancelamento', c: 'Pedidos podem ser cancelados pelo estabelecimento em caso de impossibilidade de atendimento. O cliente será notificado sobre qualquer cancelamento.' },
        { t: '7. Responsabilidade', c: 'O estabelecimento é responsável pela qualidade dos produtos fornecidos. A plataforma de cardápio digital é responsável apenas pela tecnologia de intermediação dos pedidos.' },
        { t: '8. Alterações', c: 'Estes termos podem ser alterados a qualquer momento. A continuidade do uso do serviço após as alterações implica na aceitação dos novos termos.' },
      ].map(({ t, c }) => (
        <div key={t} style={{ marginBottom: 20 }}>
          <h4 style={{ fontWeight: 700, marginBottom: 6, color: '#333' }}>{t}</h4>
          <p style={{ color: '#666', fontSize: '.9rem' }}>{c}</p>
        </div>
      ))}
    </PaginaInstitucional>
  );
}

export function Privacidade() {
  return (
    <PaginaInstitucional titulo="Política de Privacidade">
      <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Política de Privacidade</h2>
      <p style={{ color: '#888', fontSize: '.85rem', marginBottom: 24 }}>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

      {[
        { t: '1. Dados Coletados', c: 'Coletamos nome, telefone, e-mail, CPF e endereço fornecidos voluntariamente no momento do pedido. Esses dados são necessários para a realização e entrega dos pedidos.' },
        { t: '2. Uso dos Dados', c: 'Seus dados são utilizados exclusivamente para: processamento e entrega do pedido, comunicação sobre o status do pedido, e melhoria dos nossos serviços.' },
        { t: '3. Compartilhamento', c: 'Não compartilhamos seus dados com terceiros, exceto quando necessário para a realização do pedido (ex: serviço de entrega) ou quando exigido por lei.' },
        { t: '4. Armazenamento', c: 'Seus dados são armazenados em servidores seguros e mantidos pelo tempo necessário para o cumprimento das finalidades descritas nesta política.' },
        { t: '5. Seus Direitos (LGPD)', c: 'Conforme a Lei Geral de Proteção de Dados (LGPD), você tem direito de acessar, corrigir, excluir ou exportar seus dados. Entre em contato conosco para exercer esses direitos.' },
        { t: '6. Segurança', c: 'Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda ou destruição.' },
        { t: '7. Cookies', c: 'Podemos utilizar cookies para melhorar sua experiência de navegação. Você pode desativá-los nas configurações do seu navegador.' },
        { t: '8. Contato', c: 'Para dúvidas ou solicitações sobre privacidade, entre em contato diretamente com o estabelecimento.' },
      ].map(({ t, c }) => (
        <div key={t} style={{ marginBottom: 20 }}>
          <h4 style={{ fontWeight: 700, marginBottom: 6, color: '#333' }}>{t}</h4>
          <p style={{ color: '#666', fontSize: '.9rem' }}>{c}</p>
        </div>
      ))}
    </PaginaInstitucional>
  );
}
